// Salesgenie Pre/Post Auth

// pre auth stuff!
jQuery('.post-auth').hide();
jQuery('.pre-auth').show();

function pre_post_auth() {

	// get the CmsCookie
	var cmsCookie = Cookies.get('CmsCookie');

	if (cmsCookie != null && cmsCookie.length > 0) {

		// decode and parse the cookie as JSON
		var cmsCookieParsed = JSON.parse(decodeURIComponent(cmsCookie));

		// check the IsAuthenticated cookie value and
		// show/hide elements based on that value
		if (cmsCookieParsed.IsAuthenticated) {
			
			// post auth stuff!
			jQuery('.post-auth').show();
			jQuery('.pre-auth').hide();

			// Sign In, Try Us, menu items
			jQuery('.ubermenu').find('#menu-item-15147, #menu-item-15148').hide();

			// USA Back to Dashboard and Logout
			jQuery('.ubermenu').find('#menu-item-15149, #menu-item-15150').show().css("display", "flex");

		}

	}
}

//Execute Function
window.onload = (event) => {
	pre_post_auth();
};

// debounced resize, fires once after all resizing stops
jQuery(window).smartresize(function() {
	pre_post_auth();
});